export default __webpack_public_path__ + "images/30bd7a4237fa1126cb33cb236100a07d-latin_music.webp";